import { all, takeEvery, takeLatest, put, call, select } from "redux-saga/effects";
import { toast } from 'react-hot-toast';
import organizationBillingAddEditSlice,  { createOrganizationBilling, loadOrganizationBilling } from "./slice";
import { IConfiguration } from "../../../shared/types";
import { SimplyTestApi } from "../../../api/simplytest";
import { selectConfig } from "../../../shared/redux/slice";
import { selectIdToken, unauthorized } from "../../../auth/redux/slice";
import { AxiosResponse } from "axios";
import { OrganizationBilling, OrganizationStripeBilling } from "../../../api/types";
import { generatePath } from "react-router-dom";
import { ROUTES } from "../../../shared/constants";
import Swal from 'sweetalert2';

export abstract class OrganizationBillingAddEditSagas {
    public static* run() {
        try {
            yield all([
                takeLatest(loadOrganizationBilling, OrganizationBillingAddEditSagas.loadOrganizationBilling),
                takeLatest(createOrganizationBilling, OrganizationBillingAddEditSagas.createOrganizationBilling),
            ]);
        }
        catch(e: any){
            toast.error('Unable to register OrganizationBillingAddEdit module.');
            console.log(`[OrganizationBillingAddEditSagas:run] the following exception has occurred`, e);
        }
    }

    public static* loadOrganizationBilling(action: ReturnType<typeof loadOrganizationBilling>){
        const { payload: { orgId }} = action;
        try {
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const loadOrgResponse: AxiosResponse<OrganizationBilling> = yield call(
                {
                    context: client,
                    fn: client.getOrganizationBilling,
                },
                orgId,
            );

            if(loadOrgResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(loadOrgResponse.status !== 200)
                throw new Error("Error communicating with Api");

            yield put(organizationBillingAddEditSlice.actions.setOrganizationBilling(loadOrgResponse.data));
        }
        catch(e: any){
            toast.error('Unable to load organization billing data.');
            console.log(`[OrganizationBillingAddEditSagas:loadOrganizationBilling] the following exception has occurred`, e);
        }
    }

    public static* createOrganizationBilling(action: ReturnType<typeof createOrganizationBilling>){
        const { payload: { organizationbilling, navigate }} = action;
        try {
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const newOrgResponse: AxiosResponse<OrganizationBilling> = yield call(
                {
                    context: client,
                    fn: client.createOrganizationBilling,
                },
                organizationbilling,
            );

            if(newOrgResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(newOrgResponse.status !== 200)  {
       	       Swal.fire({ 
	          icon: "error",
  	          title: "Invalid Organization Billing Record. Please review and try again, or cancel for now...",
	          text: newOrgResponse.data.xActId, 
	       });
               //throw new Error("Error communicating with Api");
	    }

            if(newOrgResponse.status === 200) {
                yield call({ context: toast, fn: toast.success}, 'An Organization Billing Record was Created.');
                navigate(generatePath(ROUTES.Dashboard));
            }
        }
        catch(e: any){
            // toast.error('Unable to create organization billing.');
       	    Swal.fire({ 
	       icon: "error",
  	       title: "Invalid Organization Billing Record",
	       text: "Could not create an Organization Billing record. Please verify that all account data is correct..." 
	    });
            console.log(`[OrganizationBillingAddEditSagas:createOrganizationBilling] the following exception has occurred`, e);
        }
    }

}
